import { render, staticRenderFns } from "./NoticesItem.vue?vue&type=template&id=13942a27&"
import script from "./NoticesItem.vue?vue&type=script&lang=js&"
export * from "./NoticesItem.vue?vue&type=script&lang=js&"
import style0 from "./NoticesItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports